import React from 'react';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const items = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta · Stripe · Bizum'
}];
export function TrustRow({
  className = ''
}: {
  className?: string;
}) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-6 gap-y-3 ${className}`} data-id="element-196" data-mp="1p1mxot0pv336">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-2 text-xs font-medium text-slate-400 sm:text-sm" data-id="element-197" data-mp="1yz17i9s4wtmi">
          <Icon className="h-4 w-4 text-ball-400" aria-hidden="true" data-id="element-198" data-mp="1ty3l1l03ddf7" />
          {label}
        </li>)}
    </ul>;
}